import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../node_modules/@slyte/router/index.js";
let LayoutComp;

class Index extends Route {
  divert() {
    if (this.navigation.info.route === 'index') {
      this.$router.navigateTo('index.fonts');
    }
  }

  render() {
    return { outlet: '#outlet', component: LayoutComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({
      didNavigate: function () {
        let currentRoute = this.$app.$router.getRouteInstance().routeName;
        let activeMenu = document.querySelector('.menu-list.active');
        let currentRouteId = currentRoute?.split('.').pop();
        let targetMenu = document.querySelector(`#${currentRouteId}.menu-list`);

        activeMenu?.classList.remove('active');
        targetMenu?.classList.add('active');
      }
    }), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(import(
      /* webpackChunkName: "components/javascript/layout-components/layout-comp" */
      "../../components/javascript/layout-components/layout-comp"
    ).then(function(res) {
      LayoutComp = res.LayoutComp;
    }));

    
;
  }
}

export { Index };
